"use client";
import Icon from "@/components/primitives/icon";
import Table, { ColumnDef } from "@/components/primitives/table";
import BettorDisplay from "@/components/bettor/bettor-display";

import React from "react";
import NotFound from "@/components/primitives/not-found";
import { formatUnits } from "@/utils";
import TablePagination, {
  TablePaginationProps,
} from "@/components/primitives/table-pagination";

export default function LeaderboardTable({
  data,
  disableLastPicks,
  pagination,
}: {
  data: any[];
  disableLastPicks?: boolean;
  pagination: TablePaginationProps;
}) {
  console.log("data from leaderboard table", data);
  const columns: ColumnDef<any>[] = React.useMemo(
    () => [
      {
        header: "rank",
        accessorFn: (row, index) => index + 1 + (pagination.size * (pagination.page - 1)),
        maxWidth: "50px",
        enableSorting: false,
      },
      {
        header: "username",
        cell: (info) => {
          const row = info.row.original;
          return (
            <BettorDisplay
              bettor={row}
              noCard
              disableLastPicks={disableLastPicks}
            />
          );
        },
      },
      {
        header: "units",
        accessorKey: "totalUnits",
        cell: (info) => {
          const value = info.getValue() as number;
          return formatUnits(value);
        },
      },
      {
        header: "win",
        accessorKey: "wins",
      },
      {
        header: "loss",
        accessorKey: "losses",
      },
      {
        header: "tie",
        accessorKey: "ties",
      },
      {
        header: "win %",
        accessorKey: "winPct",
        minWidth: "80px",
        accessorFn: (info) => {
          return Math.round(info.winRate);
        },
        cell: (info) => {
          const value: number = info.getValue() as number;
          // const diff: number = info.row.original.unitDiffPct;
          return (
            <div className="flex flex-row">
              <sup>
                {value >= 50 ? (
                  <Icon name="arrow-button-up" className="fill-success-300" />
                ) : (
                  <Icon name="arrow-button-down" className="fill-error-300" />
                )}
              </sup>

              <div>{value}%</div>
            </div>
          );
        },
      },
      {
        header: "total picks",
        accessorKey: "totalPicks",
        minWidth: "100px",
      },
      // {
      //   header: "achievements",
      //   accessorFn: (info) => {
      //     return `${info.achievements.length}`;
      //   },
      // },
    ],
    [data, pagination]
  );
  return (
    <Table
      columns={columns}
      data={data}
      type="banded"
      initialSort={{ column: "units", direction: "desc" }}
      fallback={<NotFound label="No top pickers found" icon="target-miss" />}
      footer={
        <TablePagination
          page={pagination.page}
          size={pagination.size}
          count={pagination.count}
          onPageChange={pagination.onPageChange}
          onPageSizeChange={pagination.onPageSizeChange}
        />
      }
    />
  );
}
